module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/planning1-829ec61c884512547e3f60d54cb7b0bf.png";